import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useAccessImperativeHandle } from "@/hooks/useAccessImperativeHandle";
import { useOrganizationStore } from "@/lib/zustand/useStore";
import { useEffect, useRef } from "react";
import { EditOrganizationModalProps } from ".";
import { OrganizationForm, OrganizationFormRef } from "../OrganizationForm";

export function EditOrganizationModal({ open, onOpenChange, onSubmitHandler, defaultValues, organization }: Readonly<EditOrganizationModalProps>) {
    const { organization: storeOrganization } = useOrganizationStore()
    if (!organization && storeOrganization) {
        organization = storeOrganization
    }
    if (!defaultValues && organization) {
        defaultValues = {
            crm_connections: organization.crm_connections ?? [],
            name: organization.name ?? "",
            organization_type: organization.organization_type ?? "organization",
        }
    }
    const organizationFormRef = useRef<OrganizationFormRef>(null);
    const resolvedOrganizationFormRef = useAccessImperativeHandle(organizationFormRef)
    useEffect(() => {
        if (open) {
            resolvedOrganizationFormRef?.resetForm()
        }
    }, [open])

    return (
        <Dialog open={open} onOpenChange={onOpenChange} defaultOpen={false}>
            <DialogContent className="">
                <DialogHeader>
                    <DialogTitle className='ps-1'>
                        <div className="p-0 m-0 text-start fw-bold">
                            Edit {organization?.name} Organization
                        </div>
                    </DialogTitle>
                </DialogHeader>
                <OrganizationForm
                    ref={organizationFormRef}
                    defaultValues={defaultValues}
                    prohibitCrmConnectionsChange
                    orgId={organization?.id}
                />
                <DialogFooter>
                    <div className="flex justify-end gap-2">
                        <Button
                            size="sm"
                            type="button"
                            variant="secondary"
                            onClick={() => onOpenChange(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            size="sm"
                            type="submit"
                            disabled={!resolvedOrganizationFormRef}
                            onClick={() => onSubmitHandler(resolvedOrganizationFormRef!.form.getValues())}
                        >
                            Submit
                        </Button>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog >
    )
}